// Détection d'un tracé déjà importé (logique pure, testée dans __tests__/duplicates.test.ts).

import { distanceM, LatLng } from './geo';

export type TrackSignature = { start: LatLng; end: LatLng; distance: number };

/**
 * Deux tracés sont considérés identiques s'ils ont la même longueur (à 0,5 % près)
 * et les mêmes départ et arrivée (à 20 m près).
 */
export function isSameTrack(a: TrackSignature, b: TrackSignature): boolean {
  const tolerance = Math.max(20, 0.005 * Math.max(a.distance, b.distance));
  return (
    Math.abs(a.distance - b.distance) <= tolerance && distanceM(a.start, b.start) <= 20 && distanceM(a.end, b.end) <= 20
  );
}

export function signatureOf(points: LatLng[], distance: number): TrackSignature {
  return { start: points[0], end: points[points.length - 1], distance };
}
